<template>
<div>
  <div class="title-bar title-h3">{{selectTitle}}</div>
  <hr class="mr-b20">
  <el-row :gutter="20">
    <el-col :span="6" style="padding-top: 7px;">
      <el-row class="title-bar title-h4 tit" style="margin-bottom: 17px;">차단 포트 목록</el-row>
      <el-table ref="exceptPortList" :data="dataList" :highlight-current-row="true" :pagination="false" :show-custom-header="true" :show-search-tool="showSearchTool" @row-click="loadPortAllowList" class="mr-b20" style="width:100%;">
        <el-table-column header-align="left" prop="portNumber" label="포트번호"></el-table-column>
        <el-table-column header-align="left" prop="label" label="TCP 포트명"></el-table-column>
      </el-table>
    </el-col>
    <el-col :span="18">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h4 tit">
            포트 접근 허용 IP/MAC 설정
          </div>
          <div class="setting-addel mr-l15">
            <el-button size="mini" :disabled="!isRowClick" @click="addAllowPort"><i class="far fa-plus"></i></el-button>
            <el-button size="mini" :disabled="!isDeleted" @click="deleteAllowPort"><i class="far fa-minus"></i></el-button>
          </div>
        </div>
        <div>
          <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
        </div>
      </el-row>
      <el-table-wrapper :data="allowDataList" :columns="allowPortColumns" :column-default="columnDefault" row-class-name="c-dblclick" @selection-change="exceptChangeSelection"
        :pagination="false" :show-custom-header="true" :show-search-tool="showSearchTool" @row-dblclick="editPortAllowList" style="width:100%;">
      </el-table-wrapper>
    </el-col>
  </el-row>
  <w-except-control-popup ref="exceptControlPopup" @reload-data="loadData"></w-except-control-popup>
</div>
</template>

<script>
import moment from 'moment';
import { isNil, cloneDeep } from 'lodash';
import { columnDefault } from '@/constants/table';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';
import ServerSettingAPI from '@/api/settings/server/server-settings';
import WExceptControlPopup from '@/views/settings/server/SecuritySettings/ExceptControlView/popup/ExceptControlPopup';

export default {
  name: 'WExceptControlListView',
  components: {
    WExceptControlPopup,
  },
  props: {
    selectPhysicalNode: Object,
  },
  data() {
    return {
      columnDefault,
      isRowClick: false,
      controlPopupType: null,
      selectTitle: '',
      isDeleted: false,
      dataList: null,
      allowDataList: null,
      showSearchTool: false,
      serverId: null,
      selectedPort: null,
      editRow: {},
      portChangeList: [],
      allowPortColumns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'label',
          label: '인증방법',
          sortable: true,
          searchable: true,
          formatter: this.getCertificationType,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'macaddress',
          label: 'MAC 주소',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'controlDesc',
          label: '허용 이유',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'startTime',
          label: '허용 시작 시각',
          sortable: true,
          searchable: false,
          formatter: this.convertDatetime,
        },
        {
          prop: 'endTime',
          label: '허용 종료 시각',
          sortable: true,
          searchable: false,
          formatter: this.convertDatetime,
        },
      ],
    };
  },
  watch: {
    selectPhysicalNode: {
      handler() {
        if (!isNil(this.selectPhysicalNode) && this.selectPhysicalNode.type === 'obj') {
          this.serverId = this.selectPhysicalNode.serverId;
          this.selectTitle = `[${this.selectPhysicalNode.label}] 포트 접근 차단`;
          this.loadData();
        }
      },
      immediate: true,
    },
    portChangeList: {
      handler() {
        if (this.portChangeList.length > 0) {
          this.isDeleted = true;
        } else {
          this.isDeleted = false;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    loadData() {
      ServerSettingAPI.getPortControlList({ serverId: this.serverId }).then((response) => {
        if (response.data.success) {
          this.dataList = cloneDeep(response.data.data);
          if (response.data.data.length > 0) {
            this.isRowClick = true;
            this.$nextTick(() => {
              this.loadPortAllowList(this.dataList[0]);
            });
          } else {
            this.isRowClick = false;
          }
        }
      });
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [getCertificationType 인증방법 값에 따른 convert method]
     * @author yelim
     */
    getCertificationType(row, column, value) {
      if (value === 'A') {
        return 'IP, MAC 인증';
      } else if (value === 'IA') {
        return 'IP 인증';
      }
      return 'MAC 인증';
    },
    exceptChangeSelection(selectVal) {
      this.portChangeList = cloneDeep(selectVal);
    },
    /**
     * [loadPortAllowList 차단 포트 목록에서 row click시 접근 허용 목록을 로드한다.]
     * @author yelim
     */
    loadPortAllowList(row) {
      this.$refs.exceptPortList.setCurrentRow(row);
      this.selectedPort = cloneDeep(row);
      ServerSettingAPI.getPortControlAllow({
        serverId: row.serverId,
        portNumber: row.portNumber,
      }).then((response) => {
        if (response.data.success) {
          this.allowDataList = cloneDeep(response.data.data);
        }
      });
    },
    /**
     * [convertDatetime 파라미터로 받아온 데이터 형태가 long이기 때문에 HH:mm 형태로 변환해야한다.]
     * @author yelim
     */
    convertDatetime(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return moment(new Date(value)).format('HH:mm');
    },
    /**
     * [addAllowPort 포트 접근 허용 목록을 추가한다.]
     * @author yelim
     */
    addAllowPort() {
      // 추가 팝업 open시 default값 세팅
      this.$refs.exceptControlPopup.open('ADD', null, this.selectPhysicalNode, this.selectedPort);
    },
    /**
     * [editPortAllowList 포트 접근 허용 목록을 수정한다.]
     * @author yelim
     */
    editPortAllowList(row) {
      // this.controlPopupType = 'EDIT';
      const data = cloneDeep(row);
      this.$refs.exceptControlPopup.open('EDIT', data, this.selectPhysicalNode, this.selectedPort);
    },
    /**
     * [deleteAllowPort 포트 접근 허용 항목을 삭제한다.]
     * @author yelim
     */
    deleteAllowPort() {
      const target = '포트 접근 허용 IP/MAC 설정';
      const action = msgUtil.action.DELETE;

      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        ServerSettingAPI.deletePortcontrolAllow(this.portChangeList).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/SecuritySettings/ExceptControlView/component/ExceptControlListView.vue